export const JobPlannerLocalRemoteVersion = {
  mfeJobPlanner: { environment: 'local' as const },
};

export const JobPlannerTestRemoteVersion = {
  mfeJobPlanner: { environment: 'test' as const, version: '2.*' },
};
